import { AutoLinkNode, LinkNode } from "@lexical/link";
import { ListItemNode, ListNode } from "@lexical/list";
import { HeadingNode } from "@lexical/rich-text";
import { TableCellNode, TableNode, TableRowNode } from "@lexical/table";
import { TextNode } from "lexical";
import { BroadcastNode } from "../nodes/broadcast-node";
import { ButtonListNode } from "../nodes/button-list-node";
import { ChannelNode } from "../nodes/channel/channel-node";
import { CustomEmojiNode } from "../nodes/custom-emoji/custom-emoji-node";
import { DataTableCellNode } from "../nodes/data-table-cell-node";
import { DataTableNode } from "../nodes/data-table-node";
import { DesignHuddleNode } from "../nodes/design-huddle-node";
import { DividerNode } from "../nodes/divider-node";
import { DynamicContentNode } from "../nodes/dynamic-content/dynamic-content-node";
import { DynamicContentToolbarNode } from "../nodes/dynamic-content/dynamic-content-toolbar-node";
import { EmojiNode } from "../nodes/emoji-node";
import { ImageNode } from "../nodes/image-node";
import { MergeTagV2Node } from "../nodes/merge-tag-node-v2";
import { NonGsmHighlightNode } from "../nodes/non-gsm-highlight-node";
import { PaperColorNode } from "../nodes/paper-color-node";
import { PollNode } from "../nodes/poll/poll-node";
import { StylableButtonNode } from "../nodes/stylable-button-node";
import { SurveyAnswersNode } from "../nodes/survey-answers/survey-answers-node";
import { SurveyLinkNode } from "../nodes/survey-link-node";
import { VideoNode } from "../nodes/video-node";

// Remember to update EDITOR_NODES
export const EDITOR_NODES_HEADLESS = {
  sms: [
    EmojiNode,
    SurveyLinkNode,
    AutoLinkNode,
    MergeTagV2Node,
    NonGsmHighlightNode,
    DynamicContentNode,
    DynamicContentToolbarNode,
  ],
  chat: [
    ListNode,
    ListItemNode,
    LinkNode,
    SurveyLinkNode,
    AutoLinkNode,
    TextNode,
    EmojiNode,
    DividerNode,
    ButtonListNode,
    ImageNode,
    DesignHuddleNode,
    MergeTagV2Node,
    DynamicContentNode,
    DynamicContentToolbarNode,
    PollNode,
    CustomEmojiNode,
    VideoNode,
    BroadcastNode,
    ChannelNode,
    SurveyAnswersNode,
  ],
  email: [
    HeadingNode,
    ListNode,
    ListItemNode,
    TableNode,
    TableCellNode,
    TableRowNode,
    DataTableNode,
    DataTableCellNode,
    LinkNode,
    SurveyLinkNode,
    AutoLinkNode,
    TextNode,
    EmojiNode,
    DividerNode,
    ImageNode,
    DesignHuddleNode,
    StylableButtonNode,
    PaperColorNode,
    MergeTagV2Node,
    DynamicContentNode,
    DynamicContentToolbarNode,
    PollNode,
    VideoNode,
    SurveyAnswersNode,
  ],
};
